/**
 * Utility function to check if we are in browser context of in NodeJS env.
 */
export const isClient = (force?: boolean | undefined): boolean =>
  typeof force === 'boolean' ? force : typeof window !== 'undefined';

/**
 * is Mobile Device
 * iPhone iPad iPod Android
 */
export const isMobile = (): boolean => {
  if (isClient()) {
    return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) || false;
  } else {
    return false;
  }
};
